export default __webpack_public_path__ + "static/media/Snd_LowerEBases.07bbc365.mp3";